import { Link } from 'react-router-dom'
import { useState } from 'react'
import { useAuthStore } from '../stores/authStore'
import { Capacitor } from '@capacitor/core'

const isNative = Capacitor.isNativePlatform()

const C = {
  navy:    '#0f1f3d',
  navyDark:'#080f1e',
  green:   '#22c55e',
  teal:    '#00C4A1',
  blue:    '#2563eb',
  orange:  '#f97316',
  slate:   '#64748b',
  light:   '#f8fafc',
  border:  '#e2e8f0',
  text:    '#1e293b',
  dim:     '#64748b',
}

function Nav({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <nav style={{ background: C.navy, borderBottom: '1px solid rgba(255,255,255,0.08)', position: 'sticky', top: 0, zIndex: 50 }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 32, height: 32, background: C.teal, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 6v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V6L12 2z" fill="white"/></svg>
          </div>
          <span style={{ color: 'white', fontWeight: 800, fontSize: 18, letterSpacing: '-0.01em' }}>
            hseq<span style={{ fontWeight: 400, color: 'rgba(255,255,255,0.55)' }}> intelligence</span>
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <a href="#pricing" style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, textDecoration: 'none' }}>Pricing</a>
          {isAuthenticated ? (
            <Link to="/dashboard" style={{ color: C.navyDark, fontSize: 14, fontWeight: 700, padding: '8px 20px', borderRadius: 8, background: C.teal, textDecoration: 'none' }}>
              Go to Dashboard →
            </Link>
          ) : (
            <>
              <a href="https://demo.hseqintelligence.com" style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14, fontWeight: 600, padding: '8px 18px', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)', textDecoration: 'none' }}>
                Try Demo
              </a>
              <Link to="/login" style={{ color: C.navyDark, fontSize: 14, fontWeight: 700, padding: '8px 20px', borderRadius: 8, background: C.teal, textDecoration: 'none' }}>
                Sign in →
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}

function Hero() {
  return (
    <section style={{ background: `linear-gradient(135deg, ${C.navyDark} 0%, ${C.navy} 60%, #0d2952 100%)`, padding: '80px 24px 72px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(0,196,161,0.15)', border: '1px solid rgba(0,196,161,0.3)', borderRadius: 999, padding: '6px 14px', marginBottom: 28 }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: C.teal, display: 'inline-block' }} />
          <span style={{ color: C.teal, fontSize: 13, fontWeight: 600 }}>Built for Australian workplaces</span>
        </div>
        <h1 style={{ color: 'white', fontSize: 'clamp(36px, 5vw, 60px)', fontWeight: 800, lineHeight: 1.1, margin: '0 0 20px', maxWidth: 780, letterSpacing: '-0.02em' }}>
          HSEQ management that<br />
          <span style={{ color: C.teal }}>actually works in the field</span>
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 18, lineHeight: 1.7, margin: '0 0 36px', maxWidth: 600 }}>
          The all-in-one WHS platform built for Australian operations — incidents, audits, permits, lone worker monitoring, and AI-powered risk analysis.
        </p>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
          <a href="https://demo.hseqintelligence.com" style={{ background: C.teal, color: C.navyDark, fontWeight: 700, fontSize: 16, padding: '14px 32px', borderRadius: 10, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            Try Demo — Free
          </a>
          <a href="/download/hseq-intelligence.apk" download style={{ color: 'white', fontSize: 15, fontWeight: 600, padding: '14px 28px', borderRadius: 10, border: '1.5px solid rgba(255,255,255,0.25)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 16l4-4m0 0l-4-4m4 4H4"/><path d="M20 12a8 8 0 11-16 0 8 8 0 0116 0z"/></svg>
            Download Android App
          </a>
        </div>
        <div style={{ display: 'flex', gap: 28, marginTop: 40, flexWrap: 'wrap' }}>
          {[['100%', 'Australian data sovereignty'], ['Instant', 'demo · no credit card required']].map(([val, label]) => (
            <div key={label}>
              <div style={{ color: C.teal, fontWeight: 800, fontSize: 22 }}>{val}</div>
              <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 13, marginTop: 2 }}>{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}


const DEMO_HIGHLIGHTS = [
  { emoji: '🏢', label: 'Pacific Infrastructure Services', desc: '3 sites across NSW — Sydney, Parramatta, Blue Mountains' },
  { emoji: '👥', label: '8 team members, 6 roles',         desc: 'Admin, Corp Safety, Safety Officer, Supervisor, Field Worker' },
  { emoji: '📊', label: '3 months of live data',           desc: '10 incidents, 5 permits, 8 corrective actions, hours data' },
  { emoji: '📱', label: 'Android app included',            desc: 'Download APK and explore the mobile field experience' },
]

function DemoSection() {
  return (
    <section style={{ background: C.navyDark, padding: '72px 24px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ color: C.teal, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Live Demo</div>
          <h2 style={{ color: 'white', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>
            Try the full platform — free, right now
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 17, maxWidth: 520, margin: '0 auto 0', lineHeight: 1.65 }}>
            A real HSEQ environment pre-loaded with 3 months of data. Sign in as any team member — no signup, no credit card.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16, marginBottom: 36 }}>
          {DEMO_HIGHLIGHTS.map(h => (
            <div key={h.label} style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '20px' }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{h.emoji}</div>
              <div style={{ color: 'white', fontWeight: 700, fontSize: 14, marginBottom: 6 }}>{h.label}</div>
              <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, lineHeight: 1.6 }}>{h.desc}</div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center' }}>
          <a href="https://demo.hseqintelligence.com" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: C.teal, color: C.navyDark, fontWeight: 700, fontSize: 16, padding: '14px 36px', borderRadius: 10, textDecoration: 'none' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            Enter Demo
          </a>
          <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13, marginTop: 10 }}>Instant access · 8 roles to explore · No account needed</p>
        </div>
      </div>
    </section>
  )
}

function AppScreenshots() {
  return (
    <section style={{ background: C.navy, padding: '72px 24px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ color: C.teal, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Mobile App</div>
          <h2 style={{ color: 'white', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>
            Designed for the field, not the office
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 17, maxWidth: 560, margin: '0 auto', lineHeight: 1.65 }}>
            Your team can report incidents, conduct audits, and check in as a lone worker — all from their phone, even without internet.
          </p>
        </div>
        <div style={{ borderRadius: 20, overflow: 'hidden', boxShadow: '0 40px 80px rgba(0,0,0,0.5)' }}>
          <img src="/app-preview.png" alt="HSEQ Intelligence mobile app in use" style={{ width: '100%', display: 'block' }} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24, marginTop: 40 }}>
          {[
            { icon: '📋', title: 'Instant Incident Reporting', desc: 'Workers report incidents in under 60 seconds with photo evidence, GPS location, and automatic notifications to supervisors.' },
            { icon: '✅', title: 'Mobile Audits', desc: 'Conduct WHS, environmental, quality, contractor, fire safety, and emergency audits on-site with offline support.' },
            { icon: '🛡️', title: 'Lone Worker Protection', desc: 'Real-time GPS check-in, scheduled safety check-ins, and one-tap SOS alerts when workers are in remote locations.' },
          ].map(f => (
            <div key={f.title} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '24px 20px' }}>
              <div style={{ fontSize: 28, marginBottom: 12 }}>{f.icon}</div>
              <div style={{ color: 'white', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>{f.title}</div>
              <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.6 }}>{f.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

const TABS = [
  { id: 'dashboard',   label: 'Dashboard',        caption: 'Real-time safety overview',          desc: 'TRIFR, open incidents, active permits, overdue actions, and recent incidents — all visible the moment you log in.',                                                    img: '/screenshots/dashboard.png' },
  { id: 'incidents',   label: 'Incidents',         caption: 'Full incident lifecycle',            desc: 'Log, triage, investigate, and close incidents from any device. AI automatically classifies severity and suggests root causes.',                                        img: '/screenshots/incidents.png' },
  { id: 'metrics',     label: 'Metrics',           caption: 'TRIFR & LTIFR tracking',            desc: 'Lagging and leading safety indicators calculated automatically from hours worked. 30-day, 90-day, YTD, and 12-month rolling views with trend charts.',                 img: '/screenshots/metrics.png' },
  { id: 'audits',      label: 'Audits',            caption: 'Audits with scored findings',       desc: 'Schedule and conduct WHS, environmental, quality, contractor, and fire safety audits — with automatic scoring and corrective action generation.',                      img: '/screenshots/audits.png' },
  { id: 'permits',     label: 'Permits to Work',   caption: 'High-risk work authorisation',      desc: 'Manage confined space, hot work, working at heights, and electrical isolation permits through a structured multi-stage approval and sign-on/off workflow.',            img: '/screenshots/permits.png' },
  { id: 'loneworker',  label: 'Lone Worker',       caption: 'Lone worker safety monitoring',     desc: 'Workers select their activity type, capture GPS, and check in on a schedule. Missed check-ins trigger automatic supervisor alerts and escalation.',                   img: '/screenshots/loneworker.png' },
]

function PlatformScreenshots() {
  const [active, setActive] = useState('dashboard')
  const tab = TABS.find(t => t.id === active)!

  return (
    <section style={{ background: 'white', padding: '80px 24px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ color: C.blue, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Platform</div>
          <h2 style={{ color: C.text, fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>
            See the platform in action
          </h2>
          <p style={{ color: C.dim, fontSize: 17, maxWidth: 520, margin: '0 auto', lineHeight: 1.65 }}>
            A purpose-built interface that gives safety teams exactly what they need — no clutter, no configuration required.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 32 }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setActive(t.id)} style={{ padding: '9px 20px', borderRadius: 999, border: active === t.id ? `2px solid ${C.blue}` : `1.5px solid ${C.border}`, background: active === t.id ? C.blue : 'white', color: active === t.id ? 'white' : C.dim, fontWeight: 600, fontSize: 14, cursor: 'pointer', transition: 'all 120ms' }}>
              {t.label}
            </button>
          ))}
        </div>
        <div style={{ background: C.light, borderRadius: 16, padding: '6px', border: `1px solid ${C.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.08)' }}>
          <div style={{ borderRadius: 12, overflow: 'hidden', lineHeight: 0 }}>
            <img key={tab.img} src={tab.img} alt={tab.caption} style={{ width: '100%', display: 'block' }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 24, marginTop: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ flex: '0 0 auto' }}>
            <div style={{ background: C.blue + '12', border: `1px solid ${C.blue}30`, borderRadius: 10, padding: '8px 16px', display: 'inline-block' }}>
              <span style={{ color: C.blue, fontWeight: 700, fontSize: 14 }}>{tab.caption}</span>
            </div>
          </div>
          <p style={{ color: C.dim, fontSize: 15, lineHeight: 1.65, margin: 0, flex: 1 }}>{tab.desc}</p>
        </div>
      </div>
    </section>
  )
}

function Comparison() {
  const rows = [
    ['Unlimited users', '✅', '✅', '❌ Per user'],
    ['Pricing model', '✅ Contact us', '❌ Per user', '❌ Per user'],
    ['Australian data storage', '✅', '✅', '❌'],
    ['Built for Australian WHS', '✅', '✅', '⚠️ Generic'],
    ['AI incident analysis', '✅', '❌', '❌'],
    ['Lone worker monitoring', '✅', '❌', '⚠️ Add-on'],
    ['Native Android app', '✅', '⚠️ Web only', '✅'],
    ['Risk register', '✅', '⚠️ Add-on', '✅'],
    ['Workers comp tracking', '✅', '❌', '❌'],
    ['Psychosocial hazard tools', '✅', '❌', '❌'],
    ['AI regulatory intelligence', '✅', '❌', '❌'],
    ['Modern mobile UX', '✅', '⚠️ Complex', '❌ Dated'],
  ]
  const colStyle = (i: number) => ({ padding: '12px 16px', textAlign: 'center' as const, fontSize: 14, fontWeight: i === 1 ? 700 : 400, color: i === 1 ? C.text : C.dim, background: i === 1 ? '#f0fdf4' : 'transparent' })
  return (
    <section style={{ background: C.light, padding: '80px 24px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ color: C.blue, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Why switch</div>
          <h2 style={{ color: C.text, fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>More features. Simpler pricing.</h2>
          <p style={{ color: C.dim, fontSize: 17, maxWidth: 520, margin: '0 auto' }}>SafetyCulture and Dunsafe charge per user and lock key features behind expensive add-ons.</p>
        </div>
        <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: `2px solid ${C.border}` }}>
                <th style={{ padding: '16px', textAlign: 'left', color: C.dim, fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Feature</th>
                {[['HSEQ Intelligence', C.teal], ['Dunsafe', C.slate], ['SafetyCulture', C.slate]].map(([name, color]) => (
                  <th key={name} style={{ padding: '16px', textAlign: 'center', color: name === 'HSEQ Intelligence' ? C.navy : C.dim, fontWeight: 800, fontSize: 15, background: name === 'HSEQ Intelligence' ? '#E6FAF6' : 'transparent', position: 'relative' }}>
                    {name === 'HSEQ Intelligence' && <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: C.teal, borderRadius: '0 0 2px 2px' }} />}
                    {name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(([feature, hseq, dunsafe, sc], i) => (
                <tr key={feature as string} style={{ borderBottom: i < rows.length - 1 ? `1px solid ${C.border}` : 'none', background: i % 2 === 0 ? 'transparent' : '#fafafa' }}>
                  <td style={{ padding: '12px 16px', color: C.text, fontSize: 14, fontWeight: 500 }}>{feature as string}</td>
                  <td style={{ ...colStyle(1), color: (hseq as string).startsWith('✅') ? '#16a34a' : C.dim }}>{hseq as string}</td>
                  <td style={{ ...colStyle(2) }}>{dunsafe as string}</td>
                  <td style={{ ...colStyle(3) }}>{sc as string}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  )
}

function Features() {
  const features = [
    { icon: '⚡', color: '#f59e0b', title: 'AI-Powered Analysis', desc: 'Automatically classify incident severity, identify root causes, and predict risk before incidents occur using built-in AI.' },
    { icon: '📍', color: '#ef4444', title: 'Lone Worker Monitoring', desc: 'GPS check-in, timed safety alerts, and one-tap SOS with automatic escalation. Built-in, not an add-on.' },
    { icon: '🇦🇺', color: '#2563eb', title: 'Australian WHS Compliance', desc: 'Built from the ground up for the Work Health and Safety Act 2011. Regulatory intelligence keeps you ahead of changes.' },
    { icon: '📊', color: '#8b5cf6', title: 'Full Incident Lifecycle', desc: 'From first report through investigation, corrective action, and closeout — everything tracked in one place.' },
    { icon: '🏗️', color: '#f97316', title: 'Contractor & Asset Management', desc: 'Track contractor inductions, licences, and competencies. Manage assets, maintenance schedules, and inspections.' },
    { icon: '💰', color: '#22c55e', title: 'Simple, Transparent Pricing', desc: 'Contact us for a quote tailored to your organisation size and needs. No hidden add-ons.' },
  ]
  return (
    <section style={{ background: 'white', padding: '80px 24px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{ color: C.orange, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Platform capabilities</div>
          <h2 style={{ color: C.text, fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>Everything your team needs, nothing they don't</h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 24 }}>
          {features.map(f => (
            <div key={f.title} style={{ padding: '28px', border: `1px solid ${C.border}`, borderRadius: 16 }}>
              <div style={{ width: 48, height: 48, background: f.color + '18', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, marginBottom: 16 }}>{f.icon}</div>
              <h3 style={{ color: C.text, fontWeight: 700, fontSize: 17, margin: '0 0 8px' }}>{f.title}</h3>
              <p style={{ color: C.dim, fontSize: 14, lineHeight: 1.65, margin: 0 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

function Pricing() {
  const plans = [
    { name: 'Starter',      features: ['Small teams', 'Core incident & audit modules', 'Mobile app access', 'Email support'] },
    { name: 'Standard',     features: ['Unlimited users', 'All modules incl. AI analysis', 'Lone worker monitoring', 'Priority support', 'Australian data storage'], highlight: true },
    { name: 'Professional', features: ['Everything in Standard', 'Advanced analytics', 'ERP integrations', 'Custom audit templates', 'Dedicated account manager'] },
    { name: 'Enterprise',   features: ['Multi-site / group', 'Custom workflows & API access', 'SLA guarantee', 'On-site training', 'Bespoke onboarding'] },
  ]
  return (
    <section id="pricing" style={{ background: C.light, padding: '80px 24px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{ color: C.teal, fontWeight: 700, fontSize: 13, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 12 }}>Pricing</div>
          <h2 style={{ color: C.text, fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>Plans for every team size</h2>
          <p style={{ color: C.dim, fontSize: 17, maxWidth: 520, margin: '0 auto' }}>Contact us to get a quote tailored to your organisation.</p>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 20 }}>
          {plans.map(p => (
            <div key={p.name} style={{ background: (p as any).highlight ? C.navy : 'white', border: (p as any).highlight ? `2px solid ${C.teal}` : `1px solid ${C.border}`, borderRadius: 18, padding: '32px 24px', position: 'relative', boxShadow: (p as any).highlight ? '0 20px 40px rgba(15,31,61,0.2)' : 'none' }}>
              {(p as any).highlight && <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: C.teal, color: C.navyDark, fontSize: 11, fontWeight: 800, padding: '4px 14px', borderRadius: 999, textTransform: 'uppercase', letterSpacing: '0.08em', whiteSpace: 'nowrap' }}>Most Popular</div>}
              <div style={{ color: (p as any).highlight ? 'rgba(255,255,255,0.6)' : C.dim, fontSize: 13, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 20 }}>{p.name}</div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px' }}>
                {p.features.map(f => (
                  <li key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 10, color: (p as any).highlight ? 'rgba(255,255,255,0.8)' : C.text, fontSize: 14 }}>
                    <span style={{ color: C.teal, fontWeight: 700, marginTop: 1, flexShrink: 0 }}>✓</span>{f}
                  </li>
                ))}
              </ul>
              <a href="mailto:info@hseqintelligence.com.au" style={{ display: 'block', textAlign: 'center', padding: '12px', borderRadius: 10, background: (p as any).highlight ? C.teal : 'transparent', color: (p as any).highlight ? C.navyDark : C.blue, fontWeight: 700, fontSize: 15, textDecoration: 'none', border: (p as any).highlight ? 'none' : `1.5px solid ${C.blue}` }}>
                Contact us
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

function Download() {
  return (
    <section style={{ background: C.navy, padding: '72px 24px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 20 }}>📱</div>
        <h2 style={{ color: 'white', fontSize: 'clamp(28px, 4vw, 38px)', fontWeight: 800, margin: '0 0 16px', letterSpacing: '-0.02em' }}>Download the Android App</h2>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 17, lineHeight: 1.65, margin: '0 0 36px' }}>
          The full HSEQ Intelligence platform in your pocket. Report incidents, conduct audits, and monitor lone workers from the field.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, maxWidth: 560, margin: '0 auto 20px' }}>
          {/* Production APK */}
          <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, padding: '1.25rem', textAlign: 'left' }}>
            <div style={{ display: 'inline-block', background: C.teal, color: C.navyDark, fontSize: '0.6875rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '2px 8px', borderRadius: 99, marginBottom: '0.625rem' }}>
              Production
            </div>
            <div style={{ color: 'white', fontWeight: 700, fontSize: '0.9375rem', marginBottom: '0.375rem' }}>Production APK</div>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.75rem', lineHeight: 1.55, margin: '0 0 1rem' }}>
              Live tenant — your real data. Sign in with your account.
            </p>
            <a href="/download/hseq-intelligence.apk" download style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: C.teal, color: C.navyDark, fontWeight: 700, fontSize: '0.8125rem', padding: '8px 14px', borderRadius: 8, textDecoration: 'none' }}>
              ↓ Download
            </a>
          </div>
          {/* Demo APK */}
          <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: '1.25rem', textAlign: 'left' }}>
            <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.7)', fontSize: '0.6875rem', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '2px 8px', borderRadius: 99, marginBottom: '0.625rem' }}>
              Demo
            </div>
            <div style={{ color: 'white', fontWeight: 700, fontSize: '0.9375rem', marginBottom: '0.375rem' }}>Demo APK</div>
            <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.75rem', lineHeight: 1.55, margin: '0 0 1rem' }}>
              Try the platform free — no account needed. Persona picker included.
            </p>
            <a href="https://demo.hseqintelligence.com/download/hseq-intelligence-demo.apk" download style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'rgba(255,255,255,0.7)', fontSize: '0.8125rem', fontWeight: 700, padding: '8px 14px', borderRadius: 8, textDecoration: 'none', border: '1px solid rgba(255,255,255,0.2)' }}>
              ↓ Download
            </a>
          </div>
        </div>
        <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>iOS coming soon</span>
      </div>
    </section>
  )
}

function Footer({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <footer style={{ background: C.navyDark, borderTop: '1px solid rgba(255,255,255,0.06)', padding: '40px 24px' }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <div>
          <div style={{ color: 'white', fontWeight: 800, fontSize: 16, marginBottom: 4 }}>
            hseq<span style={{ fontWeight: 400, color: 'rgba(255,255,255,0.4)' }}> intelligence</span>
          </div>
          <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 13 }}>© 2026 HSEQ Intelligence. Data stored in Australia.</div>
        </div>
        <div style={{ display: 'flex', gap: 24 }}>
          {isAuthenticated ? (
            <Link to="/dashboard" style={{ color: C.teal, fontSize: 13, textDecoration: 'none', fontWeight: 600 }}>Dashboard →</Link>
          ) : (
            <>
              <a href="https://demo.hseqintelligence.com" style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, textDecoration: 'none' }}>Try Demo</a>
              <Link to="/login" style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, textDecoration: 'none' }}>Sign in</Link>
            </>
          )}
          <a href="mailto:support@hseqintelligence.com.au" style={{ color: 'rgba(255,255,255,0.45)', fontSize: 13, textDecoration: 'none' }}>Contact</a>
        </div>
      </div>
    </footer>
  )
}

export default function Landing() {
  const { isAuthenticated, tokenValidated } = useAuthStore()

  // On native app go straight to login; wait for token validation before rendering
  if (!tokenValidated) return null
  if (isNative) return null  // handled by router's Navigate to /login

  const authenticated = isAuthenticated

  return (
    <div style={{ minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <Nav isAuthenticated={authenticated} />
      <Hero />
      <DemoSection />
      <AppScreenshots />
      <PlatformScreenshots />
      <Comparison />
      <Features />
      <Pricing />
      <Download />
      <Footer isAuthenticated={authenticated} />
    </div>
  )
}
